// Quadros (kanbans/cronogramas) — ver docs/API.md do marketingbackgo, seção "Quadros".
import type { ColorName } from '@/utils/colors';

/** `daily`: cada um vê as suas (gestor vê as dos subordinados); `event`/`project`: compartilhado. */
export type BoardType = 'daily' | 'event' | 'project';

export interface BoardColumn {
  id: number;
  board_id: number;
  name: string;
  sort_order: number;
  color: ColorName | string;
  is_done_column: boolean;
  wip_limit?: number;
}

export interface BoardMember {
  board_id: number;
  team_member_id: number;
  name: string;
  email: string;
}

export interface Board {
  id: number;
  name: string;
  description?: string;
  board_type: BoardType;
  is_main: boolean;
  start_date?: string;
  end_date?: string;
  color: ColorName | string;
  is_archived: boolean;
  is_active: boolean;
  columns?: BoardColumn[];
  members?: BoardMember[];
  open_count: number;
  overdue_count: number;
  created_at: string;
  created_by: string;
  updated_at?: string;
  last_updated_by?: string;
}

export interface BoardFormData {
  name: string;
  description?: string | null;
  board_type: BoardType;
  is_main: boolean;
  start_date?: string | null;
  end_date?: string | null;
  color?: string;
  is_archived: boolean;
  /** Só na criação; depois use PUT /boards/:id/members. */
  member_ids?: number[];
}

export interface BoardColumnFormData {
  name: string;
  color?: string;
  is_done_column: boolean;
  wip_limit?: number | null;
}

export const BOARD_TYPE_LABELS: Record<BoardType, string> = {
  daily: 'Dia a dia',
  event: 'Evento',
  project: 'Projeto',
};

/** Quadro compartilhado = todos os membros veem tudo (evento/projeto). */
export const isSharedBoard = (board: Pick<Board, 'board_type'>): boolean => board.board_type !== 'daily';
